import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// ✅ تابع کمکی: خانه‌ی مناسب هر نقش
const getHomeForRole = (role) => {
  switch (role) {
    case 'student': return '/StudentHome';
    case 'teacher': return '/TeacherHome';
    case 'parent':  return '/ParentHome';
    case 'admin':   return '/AdminHome';
    default:        return '/login';
  }
};

export default function ProtectedRoute({ children, allowedRoles }) {
  // ✅ از AuthContext استفاده کن — user کامل با role از سرور میاد
  const { user } = useAuth();

  // ⏳ اگر userId در localStorage هست ولی user هنوز از سرور نیامده
  // → منتظر بمون (نه redirect، نه allow)
  const hasStoredUserId =
    typeof window !== 'undefined' && !!localStorage.getItem('userId');

  if (!user && hasStoredUserId) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          fontSize: 16,
          color: '#64748b',
          fontFamily: 'inherit',
        }}
      >
        ⏳ در حال بارگذاری...
      </div>
    );
  }

  // 🚫 کاربر وارد نشده → login
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // 🚫 نقش نداره (نادر) → login
  if (!user.role) {
    console.warn('⚠️ User has no role, redirecting to /login');
    return <Navigate to="/login" replace />;
  }

  // 🚫 نقش کاربر در لیست مجاز نیست → خانه‌ی خودش
  if (allowedRoles && !allowedRoles.includes(user.role)) {
    const homeForRole = getHomeForRole(user.role);
    console.warn(
      `⚠️ Role "${user.role}" not allowed. Redirecting to ${homeForRole}`
    );
    return <Navigate to={homeForRole} replace />;
  }

  // ✅ دسترسی مجاز
  return children;
}